(function () {
  if (typeof window === 'undefined') return;

  var formatMoney = function (cents, moneyFormat) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, moneyFormat);
    }
    var amount = (Number(cents) || 0) / 100;
    var amountWithCommas = amount.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

    if (typeof moneyFormat === 'string' && moneyFormat.indexOf('{{') !== -1) {
      return moneyFormat.replace(/\{\{\s*amount(?:_with_comma_separator)?\s*\}\}/, amountWithCommas);
    }

    return '$' + amountWithCommas;
  };

  var parseJSON = function (scriptEl) {
    try {
      return JSON.parse(scriptEl.textContent);
    } catch (e) {
      return null;
    }
  };

  var initialize = function (root) {
    var sectionId = root.dataset.sectionId;
    var dataScript = document.getElementById('CustomProductData-' + sectionId);
    if (!dataScript) return;

    var data = parseJSON(dataScript);
    if (!data || !data.variants) return;

    var moneyFormat = root.dataset.moneyFormat;
    var dfmFeeCents = parseInt(root.dataset.dfmFeeCents, 10) || 0;
    var designFeeVariantId = String(root.dataset.designFeeVariantId || '57506302820492').trim();
    var productFormId = root.dataset.productFormId || '';
    var isDefaultCustomTemplate = !!root.closest('[data-default-custom-product="true"]');

    var optionSelects = root.querySelectorAll('[data-option-select]');
    var optionLabels = root.querySelectorAll('[data-option-label]');
    var optionPreviews = root.querySelectorAll('[data-option-preview]');
    var pills = root.querySelectorAll('[data-option-pill]');
    var sizeSelect = root.querySelector('[data-size-select]');
    var customDims = root.querySelector('[data-custom-dims]');
    var customWidthInput = root.querySelector('[data-custom-width-input]');
    var customHeightInput = root.querySelector('[data-custom-height-input]');
    var customDimsError = root.querySelector('[data-custom-dims-error]');
    var customDimsSummary = root.querySelector('[data-custom-dims-summary]');

    var qtyInput = root.querySelector('[data-qty-input]');
    var qtyMinus = root.querySelector('[data-qty-minus]');
    var qtyPlus = root.querySelector('[data-qty-plus]');
    var qtyLabel = root.querySelector('[data-qty-label]');
    var totalPrice = root.querySelector('[data-total-price]');
    var unitLine = root.querySelector('[data-unit-line]');
    var tierStrip = root.querySelector('[data-tier-strip]');

    var extraInputs = root.querySelectorAll('[data-extra-option]');
    var extraOptionButtons = root.querySelectorAll('[data-extra-option-button]');
    var extraGroups = root.querySelectorAll('[data-extra-group]');
    var vselTriggers = root.querySelectorAll('[data-vsel-trigger]');

    var designButton = root.querySelector('[data-design-online]');
    var uploadButton = root.querySelector('[data-upload-open]');
    var browseTemplates = root.querySelector('[data-browse-templates]');
    var dfmButton = root.querySelector('[data-dfm-open]');

    var uploadModal = root.querySelector('[data-upload-modal]');
    var dfmModal = root.querySelector('[data-dfm-modal]');

    var uploadFileInput = root.querySelector('[data-upload-file]');
    var uploadZone = root.querySelector('[data-upload-zone]');
    var uploadZoneDefault = root.querySelector('[data-upload-default]');
    var uploadZoneFile = root.querySelector('[data-upload-file-row]');
    var uploadFileName = root.querySelector('[data-upload-file-name]');
    var uploadFileMeta = root.querySelector('[data-upload-file-meta]');
    var uploadError = root.querySelector('[data-upload-error]');
    var uploadErrorMsg = root.querySelector('[data-upload-error-msg]');
    var uploadSaveBtn = root.querySelector('[data-upload-save]');
    var uploadSaveText = root.querySelector('[data-upload-save-text]');
    var uploadSuccess = root.querySelector('[data-upload-success]');
    var uploadFormContent = root.querySelector('[data-upload-form]');
    var uploadFooter = root.querySelector('[data-upload-footer]');
    var uploadSize = root.querySelector('[data-upload-size]');
    var uploadOrientation = root.querySelector('[data-upload-orientation]');
    var uploadQty = root.querySelector('[data-upload-qty]');
    var uploadTotal = root.querySelector('[data-upload-total]');
    var uploadPmsInput = root.querySelector('[data-upload-pms]');
    var uploadCommentsInput = root.querySelector('[data-upload-comments]');
    var uploadSelectionSummary = root.querySelector('[data-upload-selection-summary]');
    var uploadSelectionList = root.querySelector('[data-upload-selection-list]');

    var dfmFormContent = root.querySelector('[data-dfm-form]');
    var dfmSuccess = root.querySelector('[data-dfm-success]');
    var dfmSubmit = root.querySelector('[data-dfm-submit]');
    var dfmDesc = root.querySelector('[data-dfm-desc]');
    var dfmFiles = root.querySelector('[data-dfm-files]');
    var dfmChoiceCards = root.querySelectorAll('[data-dfm-choice-card]');
    var dfmSummary = root.querySelector('[data-dfm-summary]');
    var dfmChoicePriceBanner = root.querySelector('[data-dfm-choice-price-banner]');
    var dfmSize = root.querySelector('[data-dfm-size]');
    var dfmSizePrice = root.querySelector('[data-dfm-size-price]');
    var dfmFinish = root.querySelector('[data-dfm-finish]');
    var dfmQtyLabel = root.querySelector('[data-dfm-qty-label]');
    var dfmSubtotal = root.querySelector('[data-dfm-subtotal]');
    var dfmTotal = root.querySelector('[data-dfm-total]');
    var dfmSubmitPrefix = root.querySelector('[data-dfm-submit-prefix]');
    var dfmSubmitTotal = root.querySelector('[data-dfm-submit-total]');
    var dfmExtraOptions = root.querySelector('[data-dfm-extra-options]');
    var dfmExtraOptionsList = root.querySelector('[data-dfm-extra-options-list]');
    var addonPropertiesContainer = root.querySelector('[data-extra-properties]');

    var selectedFile = null;
    var currentVariant = null;
    var dfmChoice = 'banner';
    var MAX_BYTES = 25 * 1024 * 1024;
    var activeTierBreaks = [];
    var tierSyncTimer = null;
    var lastOrientationMode = '';

    var parseLooseNumber = function (rawValue) {
      if (rawValue === null || rawValue === undefined) return NaN;
      if (typeof rawValue === 'number') return Number.isFinite(rawValue) ? rawValue : NaN;

      var raw = String(rawValue).trim();
      if (!raw) return NaN;

      if (raw.charAt(0) === '{' || raw.charAt(0) === '[') {
        try {
          var parsed = JSON.parse(raw);
          if (parsed && typeof parsed === 'object') {
            if (parsed.amount !== undefined) return parseLooseNumber(parsed.amount);
            if (parsed.value !== undefined) return parseLooseNumber(parsed.value);
          }
        } catch (e) {
          // Continue with fallback parsing.
        }
      }

      var amountMatch = raw.match(/"amount"\s*:\s*"([^"]+)"/i);
      if (amountMatch && amountMatch[1]) {
        var amountValue = parseLooseNumber(amountMatch[1]);
        if (Number.isFinite(amountValue)) return amountValue;
      }

      var cleaned = raw.replace(/[^\d.,-]/g, '');
      if (!cleaned) return NaN;

      var lastComma = cleaned.lastIndexOf(',');
      var lastDot = cleaned.lastIndexOf('.');

      if (lastComma !== -1 && lastDot !== -1) {
        if (lastComma > lastDot) {
          cleaned = cleaned.replace(/\./g, '').replace(',', '.');
        } else {
          cleaned = cleaned.replace(/,/g, '');
        }
      } else if (lastComma !== -1) {
        var commaCount = (cleaned.match(/,/g) || []).length;
        if (commaCount > 1) {
          cleaned = cleaned.replace(/,/g, '');
        } else {
          var commaParts = cleaned.split(',');
          if (commaParts.length === 2 && commaParts[1].length <= 2) {
            cleaned = commaParts[0] + '.' + commaParts[1];
          } else {
            cleaned = cleaned.replace(/,/g, '');
          }
        }
      } else {
        cleaned = cleaned.replace(/,/g, '');
      }

      var parsedNumber = parseFloat(cleaned);
      return Number.isFinite(parsedNumber) ? parsedNumber : NaN;
    };

    var parseRangeFt = function (rawValue) {
      var result = { min: null, max: null };
      var raw = String(rawValue || '').trim();
      if (!raw) return result;

      var normalized = raw
        .replace(/[–—]/g, '-')
        .replace(/\bto\b/gi, '-')
        .replace(/:/g, '-')
        .replace(/;/g, '-');
      var parts = normalized.match(/\d+(?:[.,]\d+)?/g) || [];
      if (parts.length < 2) return result;

      var min = parseLooseNumber(parts[0]);
      var max = parseLooseNumber(parts[1]);

      if (Number.isFinite(min) && min > 0) result.min = min;
      if (Number.isFinite(max) && max > 0) result.max = max;

      if (result.min && result.max && result.min > result.max) {
        var tmp = result.min;
        result.min = result.max;
        result.max = tmp;
      }

      return result;
    };

    var widthRangeFt = parseRangeFt(root.dataset.customWidthRangeFt);
    var heightRangeFt = parseRangeFt(root.dataset.customHeightRangeFt);

    var customMinWidthFt = widthRangeFt.min !== null ? widthRangeFt.min : parseLooseNumber(root.dataset.customMinWidthFt || '');
    var customMinHeightFt = heightRangeFt.min !== null ? heightRangeFt.min : parseLooseNumber(root.dataset.customMinHeightFt || '');
    var customMaxWidthFt = widthRangeFt.max !== null ? widthRangeFt.max : parseLooseNumber(root.dataset.customMaxWidthFt || '');
    var customMaxHeightFt = heightRangeFt.max !== null ? heightRangeFt.max : parseLooseNumber(root.dataset.customMaxHeightFt || '');
    var customPricePerSqft = parseLooseNumber(root.dataset.customPricePerSqft || '');

    if (!Number.isFinite(customMinWidthFt) || customMinWidthFt <= 0) customMinWidthFt = null;
    if (!Number.isFinite(customMinHeightFt) || customMinHeightFt <= 0) customMinHeightFt = null;
    if (!Number.isFinite(customMaxWidthFt) || customMaxWidthFt <= 0) customMaxWidthFt = null;
    if (!Number.isFinite(customMaxHeightFt) || customMaxHeightFt <= 0) customMaxHeightFt = null;
    if (!Number.isFinite(customPricePerSqft) || customPricePerSqft <= 0) customPricePerSqft = null;

    var baseMinWidthFt = customMinWidthFt;
    var baseMinHeightFt = customMinHeightFt;
    var baseMaxWidthFt = customMaxWidthFt;
    var baseMaxHeightFt = customMaxHeightFt;

    var customSizeTriggerTerms = (function () {
      var defaults = ['custom', 'custom size', 'cut to size', 'cut size', 'cut-to-size', 'variable', 'enter size'];
      var raw = String(root.dataset.customSizeTrigger || '');
      var fromData = raw
        .split(',')
        .map(function (term) { return String(term || '').trim().toLowerCase(); })
        .filter(function (term) { return !!term; });
      return Array.from(new Set(fromData.concat(defaults)));
    })();

    var optionImageLookup = {};
    data.variants.forEach(function (variant) {
      if (!variant || !variant.option_images || !variant.options) return;
      Object.keys(variant.option_images).forEach(function (key) {
        var imageUrl = variant.option_images[key];
        if (!imageUrl) return;

        var optionIndex = parseInt(key, 10) - 1;
        if (isNaN(optionIndex) || optionIndex < 0) return;

        var optionValue = variant.options[optionIndex];
        if (!optionValue) return;

        if (!optionImageLookup[key]) optionImageLookup[key] = {};
        if (!optionImageLookup[key][optionValue]) {
          optionImageLookup[key][optionValue] = imageUrl;
        }
      });
    });

    var modalOverlays = [uploadModal, dfmModal].filter(Boolean);
    if (modalOverlays.length) {
      var modalPortalId = 'CustomProductOptionsModalPortal-' + sectionId;
      var modalPortal = document.getElementById(modalPortalId);
      if (!modalPortal) {
        modalPortal = document.createElement('div');
        modalPortal.id = modalPortalId;
        modalPortal.className = 'custom-product-options modal-portal';
        modalPortal.dataset.sectionId = sectionId;
        document.body.appendChild(modalPortal);
      }

      modalOverlays.forEach(function (modal) {
        var modalId = modal.dataset.modalId || '';
        if (modalId) {
          document
            .querySelectorAll('[data-modal-id="' + modalId + '"][data-modal-section="' + sectionId + '"]')
            .forEach(function (existingModal) {
              if (existingModal !== modal) {
                existingModal.remove();
              }
            });
        }
        modalPortal.appendChild(modal);
      });
    }

    var getSelectedOptions = function () {
      return Array.prototype.map.call(optionSelects, function (select) {
        return select.value;
      });
    };

    var getOptionValueByName = function (keyword) {
      var normalized = (keyword || '').toLowerCase();
      if (!normalized || !data.options || !optionSelects || !optionSelects.length) return '';
      for (var i = 0; i < data.options.length; i++) {
        var name = (data.options[i] || '').toLowerCase();
        if (name.indexOf(normalized) !== -1 && optionSelects[i]) {
          return optionSelects[i].value;
        }
      }
      return '';
    };

    var getVariantLabel = function () {
      var size = getOptionValueByName('size');
      var orientation = getOptionValueByName('orientation');
      if (size || orientation) {
        return [size, orientation].filter(Boolean).join(' - ');
      }
      return getSelectedOptions().join(' - ');
    };

    var getSelectedFinishLabel = function () {
      var finishLabel = '';
      extraGroups.forEach(function (group) {
        if (finishLabel) return;
        if ((group.dataset.groupStyle || '').toLowerCase() !== 'finish') return;
        var selected = group.querySelector('[data-extra-option-button].active');
        if (selected && selected.dataset.label) {
          finishLabel = selected.dataset.label;
        }
      });
      return finishLabel || 'Selected finish';
    };

    var findVariant = function () {
      var selectedOptions = getSelectedOptions();
      return data.variants.find(function (variant) {
        if (!variant.options || variant.options.length !== selectedOptions.length) return false;
        for (var i = 0; i < selectedOptions.length; i++) {
          if (variant.options[i] !== selectedOptions[i]) return false;
        }
        return true;
      });
    };

    var getQuantity = function () {
      var value = parseInt(qtyInput.value, 10);
      if (isNaN(value) || value < 1) return 1;
      return value;
    };

    var isCustomSizeSelected = function () {
      if (!sizeSelect) return false;
      var selectedValue = String(sizeSelect.value || '').toLowerCase().trim();
      if (!selectedValue) return false;

      for (var i = 0; i < customSizeTriggerTerms.length; i++) {
        if (selectedValue.indexOf(customSizeTriggerTerms[i]) !== -1) return true;
      }

      return false;
    };

    var parseDimensionFeet = function (rawValue) {
      var parsed = parseLooseNumber(rawValue);
      return Number.isFinite(parsed) ? parsed : NaN;
    };

    var formatFeetValue = function (value) {
      if (!Number.isFinite(value)) return '';
      return String(Math.round(value * 100) / 100).replace(/\.00$/, '').replace(/(\.\d)0$/, '$1');
    };

    var getOrientationMode = function () {
      var raw = String(getOptionValueByName('orientation') || '').toLowerCase();
      if (raw.indexOf('portrait') !== -1) return 'portrait';
      if (raw.indexOf('landscape') !== -1) return 'landscape';
      return '';
    };

    var getEffectiveDimensionLimits = function () {
      var orientationMode = getOrientationMode();
      var limits = {
        widthMin: baseMinWidthFt,
        widthMax: baseMaxWidthFt,
        heightMin: baseMinHeightFt,
        heightMax: baseMaxHeightFt
      };

      if (orientationMode === 'portrait') {
        limits.widthMin = baseMinHeightFt;
        limits.widthMax = baseMaxHeightFt;
        limits.heightMin = baseMinWidthFt;
        limits.heightMax = baseMaxWidthFt;
      }

      return limits;
    };

    var formatLimitText = function (minValue, maxValue) {
      var hasMin = Number.isFinite(minValue) && minValue > 0;
      var hasMax = Number.isFinite(maxValue) && maxValue > 0;
      if (hasMin && hasMax) return 'Min ' + formatFeetValue(minValue) + "' - Max " + formatFeetValue(maxValue) + "'";
      if (hasMin) return 'Min ' + formatFeetValue(minValue) + "'";
      if (hasMax) return 'Max ' + formatFeetValue(maxValue) + "'";
      return 'No min/max set';
    };

    var formatRangePlaceholder = function (minValue, maxValue) {
      var hasMin = Number.isFinite(minValue) && minValue > 0;
      var hasMax = Number.isFinite(maxValue) && maxValue > 0;
      if (hasMin && hasMax) return formatFeetValue(minValue) + '-' + formatFeetValue(maxValue);
      if (hasMin) return '>=' + formatFeetValue(minValue);
      if (hasMax) return '<=' + formatFeetValue(maxValue);
      return 'Enter value';
    };

    var updateCustomDimensionInputMeta = function (limits) {
      var currentLimits = limits || getEffectiveDimensionLimits();

      if (customWidthInput) {
        customWidthInput.setAttribute(
          'placeholder',
          formatRangePlaceholder(currentLimits.widthMin, currentLimits.widthMax)
        );
        customWidthInput.setAttribute('title', formatLimitText(currentLimits.widthMin, currentLimits.widthMax));
      }

      if (customHeightInput) {
        customHeightInput.setAttribute(
          'placeholder',
          formatRangePlaceholder(currentLimits.heightMin, currentLimits.heightMax)
        );
        customHeightInput.setAttribute('title', formatLimitText(currentLimits.heightMin, currentLimits.heightMax));
      }
    };

    var normalizeCustomDimensionsForOrientation = function () {
      var orientationMode = getOrientationMode();
      if (!orientationMode) return;

      if (!isCustomSizeSelected()) {
        lastOrientationMode = orientationMode;
        return;
      }

      if (!customWidthInput || !customHeightInput) {
        lastOrientationMode = orientationMode;
        return;
      }

      if (lastOrientationMode === orientationMode) return;

      var width = parseDimensionFeet(customWidthInput.value);
      var height = parseDimensionFeet(customHeightInput.value);
      if (!Number.isFinite(width) || width <= 0 || !Number.isFinite(height) || height <= 0) {
        lastOrientationMode = orientationMode;
        return;
      }

      if (orientationMode === 'landscape' && width < height) {
        customWidthInput.value = formatFeetValue(height);
        customHeightInput.value = formatFeetValue(width);
      } else if (orientationMode === 'portrait' && width > height) {
        customWidthInput.value = formatFeetValue(height);
        customHeightInput.value = formatFeetValue(width);
      }

      lastOrientationMode = orientationMode;
    };

    var getCustomDimensionsValidation = function () {
      var result = {
        active: isCustomSizeSelected(),
        valid: true,
        width: NaN,
        height: NaN,
        areaSqFt: NaN,
        message: ''
      };

      if (!result.active) return result;

      result.width = parseDimensionFeet(customWidthInput ? customWidthInput.value : '');
      result.height = parseDimensionFeet(customHeightInput ? customHeightInput.value : '');

      if (!Number.isFinite(result.width) || result.width <= 0 || !Number.isFinite(result.height) || result.height <= 0) {
        result.valid = false;
        result.message = 'Enter valid width and height to price your custom size.';
        return result;
      }

      var limits = getEffectiveDimensionLimits();
      var minWidth = limits.widthMin || (customWidthInput ? parseDimensionFeet(customWidthInput.getAttribute('min')) : NaN) || 0.5;
      var minHeight = limits.heightMin || (customHeightInput ? parseDimensionFeet(customHeightInput.getAttribute('min')) : NaN) || 0.5;
      var maxWidth = limits.widthMax;
      var maxHeight = limits.heightMax;

      if (result.width < minWidth) {
        result.valid = false;
        result.message = 'Minimum custom width is ' + formatFeetValue(minWidth) + ' ft.';
        return result;
      }

      if (result.height < minHeight) {
        result.valid = false;
        result.message = 'Minimum custom height is ' + formatFeetValue(minHeight) + ' ft.';
        return result;
      }

      if (Number.isFinite(maxWidth) && result.width > maxWidth) {
        result.valid = false;
        result.message = 'Maximum custom width is ' + formatFeetValue(maxWidth) + ' ft.';
        return result;
      }

      if (Number.isFinite(maxHeight) && result.height > maxHeight) {
        result.valid = false;
        result.message = 'Maximum custom height is ' + formatFeetValue(maxHeight) + ' ft.';
        return result;
      }

      result.areaSqFt = result.width * result.height;
      return result;
    };

    var getCustomUnitPriceCents = function (validation) {
      var details = validation || getCustomDimensionsValidation();
      if (!details.active || !details.valid) return NaN;
      if (!customPricePerSqft || !Number.isFinite(details.areaSqFt) || details.areaSqFt <= 0) return NaN;
      return Math.round((details.areaSqFt * customPricePerSqft * 100) + Number.EPSILON);
    };

    var updateCustomDimsFeedback = function (validation) {
      var details = validation || getCustomDimensionsValidation();

      if (!customDimsError || !customDimsSummary) return;

      if (!details.active) {
        customDimsError.hidden = true;
        customDimsError.textContent = '';
        customDimsSummary.hidden = true;
        customDimsSummary.textContent = '';
        if (customWidthInput) customWidthInput.classList.remove('invalid');
        if (customHeightInput) customHeightInput.classList.remove('invalid');
        return;
      }

      var widthRaw = customWidthInput ? String(customWidthInput.value || '').trim() : '';
      var heightRaw = customHeightInput ? String(customHeightInput.value || '').trim() : '';
      if (!widthRaw && !heightRaw) {
        customDimsError.hidden = true;
        customDimsError.textContent = '';
        customDimsSummary.hidden = true;
        customDimsSummary.textContent = '';
        if (customWidthInput) customWidthInput.classList.remove('invalid');
        if (customHeightInput) customHeightInput.classList.remove('invalid');
        return;
      }

      if (!details.valid) {
        customDimsError.hidden = false;
        customDimsError.textContent = details.message;
        customDimsSummary.hidden = true;
        customDimsSummary.textContent = '';
        if (customWidthInput) customWidthInput.classList.add('invalid');
        if (customHeightInput) customHeightInput.classList.add('invalid');
        return;
      }

      var summary = formatFeetValue(details.width) + "' x " + formatFeetValue(details.height) + "' (" + formatFeetValue(details.areaSqFt) + ' sq ft)';
      var customUnitCents = getCustomUnitPriceCents(details);
      if (Number.isFinite(customUnitCents)) {
        summary += ' • ' + formatMoney(customUnitCents, moneyFormat) + ' each';
      }

      customDimsError.hidden = true;
      customDimsError.textContent = '';
      customDimsSummary.hidden = false;
      customDimsSummary.textContent = summary;
      if (customWidthInput) customWidthInput.classList.remove('invalid');
      if (customHeightInput) customHeightInput.classList.remove('invalid');
    };

    var getActiveUnitPriceForQuantity = function (variant, quantity) {
      var customValidation = getCustomDimensionsValidation();
      var customUnitCents = getCustomUnitPriceCents(customValidation);
      if (customValidation.active && Number.isFinite(customUnitCents) && customUnitCents > 0) {
        return getCustomUnitPriceForQuantity(customUnitCents, quantity, variant);
      }
      return getUnitPriceForQuantity(variant, quantity);
    };

    var getCustomSizeProperties = function () {
      var details = getCustomDimensionsValidation();
      if (!details.active || !details.valid) return [];

      var rows = [
        { name: 'Custom Width (ft)', value: formatFeetValue(details.width) },
        { name: 'Custom Height (ft)', value: formatFeetValue(details.height) },
        { name: 'Custom Area (sq ft)', value: formatFeetValue(details.areaSqFt) }
      ];

      if (customPricePerSqft) {
        rows.push({ name: 'Custom Price Per Sq Ft', value: formatMoney(Math.round(customPricePerSqft * 100), moneyFormat) });
      }

      return rows;
    };

    var applyCustomDimensionInputLimits = function () {
      var limits = getEffectiveDimensionLimits();
      var widthMin = Number.isFinite(limits.widthMin) && limits.widthMin > 0 ? limits.widthMin : 0.5;
      var heightMin = Number.isFinite(limits.heightMin) && limits.heightMin > 0 ? limits.heightMin : 0.5;

      if (customWidthInput) {
        customWidthInput.setAttribute('min', String(widthMin));
        if (Number.isFinite(limits.widthMax) && limits.widthMax > 0) {
          customWidthInput.setAttribute('max', String(limits.widthMax));
        } else {
          customWidthInput.removeAttribute('max');
        }
      }
      if (customHeightInput) {
        customHeightInput.setAttribute('min', String(heightMin));
        if (Number.isFinite(limits.heightMax) && limits.heightMax > 0) {
          customHeightInput.setAttribute('max', String(limits.heightMax));
        } else {
          customHeightInput.removeAttribute('max');
        }
      }

      updateCustomDimensionInputMeta(limits);
    };

    var parseMoneyValue = function (rawValue) {
      if (rawValue === null || rawValue === undefined) return NaN;
      var raw = String(rawValue).trim();
      if (!raw) return NaN;

      var commaDecimal = /,\d{2}\b/.test(raw) && (raw.match(/\./g) || []).length >= (raw.match(/,/g) || []).length;
      var normalized = raw.replace(/[^\d.,-]/g, '');
      if (!normalized) return NaN;

      if (commaDecimal) {
        normalized = normalized.replace(/\./g, '').replace(',', '.');
      } else {
        normalized = normalized.replace(/,/g, '');
      }

      var parsed = parseFloat(normalized);
      return isNaN(parsed) ? NaN : parsed;
    };

    var moneyToCents = function (rawValue) {
      var amount = parseMoneyValue(rawValue);
      if (isNaN(amount)) return NaN;
      return Math.round((amount + Number.EPSILON) * 100);
    };

    var parseTierMinQuantity = function (rawValue) {
      var text = String(rawValue || '');
      if (!text) return NaN;

      var plus = text.match(/(\d+)\s*\+\s*$/);
      if (plus) return parseInt(plus[1], 10);

      var range = text.match(/^\s*(\d+)\s*[\-\u2013]\s*\d+/);
      if (range) return parseInt(range[1], 10);

      var exact = text.match(/^\s*(\d+)\s*$/);
      if (exact) return parseInt(exact[1], 10);

      var any = text.match(/(\d+)/);
      return any ? parseInt(any[1], 10) : NaN;
    };

    var findAiodTierTable = function () {
      var scope = root.closest('.product__info-wrapper') || document.querySelector('.product__info-wrapper') || document;
      var tables = Array.prototype.slice.call(
        scope.querySelectorAll('.csapps-volume-discount-tiers table.csapps-table, #tdf_wholesale')
      );

      if (!tables.length && scope !== document) {
        tables = Array.prototype.slice.call(document.querySelectorAll('.csapps-volume-discount-tiers table.csapps-table, #tdf_wholesale'));
      }
      if (!tables.length) return null;

      var table = null;
      for (var tableIndex = 0; tableIndex < tables.length; tableIndex++) {
        if (isElementVisible(tables[tableIndex])) {
          table = tables[tableIndex];
          break;
        }
      }
      return table || tables[0];
    };

    var parseAiodEachCentsFromRow = function (row, fallbackBasePriceCents) {
      if (!row) return NaN;

      var fallback = parseInt(fallbackBasePriceCents, 10) || 0;
      var eachCents = NaN;

      var eachEl = row.querySelector('.calc--each, .calc.calc--each');
      if (eachEl) {
        eachCents = moneyToCents(eachEl.textContent);
      }

      var rowText = (row.textContent || '').toLowerCase();
      if (!Number.isFinite(eachCents)) {
        var percentMatch = rowText.match(/(\d+(?:\.\d+)?)\s*%\s*off/);
        if (percentMatch && fallback > 0) {
          var pct = parseFloat(percentMatch[1]);
          if (!isNaN(pct)) {
            var offCents = Math.floor(fallback * (pct / 100) + Number.EPSILON);
            eachCents = Math.max(0, fallback - offCents);
          }
        }
      }

      if (!Number.isFinite(eachCents)) {
        var moneyOffMatch =
          rowText.match(/([$\u00A3\u20AC]?\s*\d+(?:[.,]\d+)?)\s*(?:off|discount)/) ||
          rowText.match(/save\s*([$\u00A3\u20AC]?\s*\d+(?:[.,]\d+)?)/);
        if (moneyOffMatch && fallback > 0) {
          var offAmountCents = moneyToCents(moneyOffMatch[1]);
          if (Number.isFinite(offAmountCents)) {
            eachCents = Math.max(0, fallback - offAmountCents);
          }
        }
      }

      if (!Number.isFinite(eachCents)) {
        var moneyNodes = row.querySelectorAll('.money, .tdf_money, .mtxt');
        var hasEachHint = /(?:each|ea\.?)/.test(rowText);
        var saysOffLike = /(?:off|save|discount)/.test(rowText);
        for (var moneyIndex = moneyNodes.length - 1; moneyIndex >= 0; moneyIndex--) {
          var parsedCents = moneyToCents(moneyNodes[moneyIndex].textContent);
          if (Number.isFinite(parsedCents) && parsedCents > 0) {
            if (saysOffLike && !hasEachHint && fallback > 0 && parsedCents < fallback) {
              eachCents = Math.max(0, fallback - parsedCents);
            } else {
              eachCents = parsedCents;
            }
            break;
          }
        }
      }

      return eachCents;
    };

    var parsePercentOffValue = function (rawText) {
      var text = String(rawText || '');
      if (!text) return NaN;
      var match = text.match(/(\d+(?:\.\d+)?)\s*%\s*off/i);
      if (!match) return NaN;
      var value = parseFloat(match[1]);
      if (!Number.isFinite(value) || value <= 0 || value >= 100) return NaN;
      return value;
    };

    var parseAiodPercentOffFromRow = function (row, fallbackBasePriceCents) {
      if (!row) return NaN;

      var cells = row.querySelectorAll('td');
      var discountCell = cells.length > 1 ? cells[1] : null;

      if (discountCell) {
        var fromOrig = parsePercentOffValue(discountCell.dataset.csOrig);
        if (Number.isFinite(fromOrig)) return fromOrig;

        var fromCell = parsePercentOffValue(discountCell.textContent);
        if (Number.isFinite(fromCell)) return fromCell;
      }

      var fromRow = parsePercentOffValue(row.textContent);
      if (Number.isFinite(fromRow)) return fromRow;

      var baseCents = parseInt(fallbackBasePriceCents, 10) || 0;
      if (baseCents <= 0) return NaN;

      var eachCents = parseAiodEachCentsFromRow(row, baseCents);
      if (!Number.isFinite(eachCents) || eachCents <= 0 || eachCents >= baseCents) return NaN;

      var percent = ((baseCents - eachCents) / baseCents) * 100;
      return Number.isFinite(percent) && percent > 0 ? percent : NaN;
    };

    var getAiodPercentBreaks = function (fallbackBasePriceCents) {
      var table = findAiodTierTable();
      if (!table) return [];

      var rows = table.querySelectorAll('tbody tr, .tdf_wholesale_level');
      if (!rows.length) return [];

      var parsed = [];

      rows.forEach(function (row) {
        var minQty = NaN;
        if (row.hasAttribute('data-q')) {
          minQty = parseInt(row.getAttribute('data-q'), 10);
        }
        if (isNaN(minQty)) {
          var firstCell = row.querySelector('td');
          minQty = parseTierMinQuantity(firstCell ? firstCell.textContent : row.textContent);
        }
        if (!Number.isFinite(minQty) || minQty < 1) return;

        var percentOff = parseAiodPercentOffFromRow(row, fallbackBasePriceCents);
        if (!Number.isFinite(percentOff) || percentOff <= 0) return;

        parsed.push({
          minimum_quantity: minQty,
          percent_off: percentOff
        });
      });

      parsed.sort(function (a, b) {
        return a.minimum_quantity - b.minimum_quantity;
      });

      var deduped = [];
      parsed.forEach(function (entry) {
        var last = deduped[deduped.length - 1];
        if (last && last.minimum_quantity === entry.minimum_quantity) {
          deduped[deduped.length - 1] = entry;
        } else {
          deduped.push(entry);
        }
      });

      return deduped;
    };

    var getAiodTierBreaks = function (fallbackBasePriceCents) {
      var table = findAiodTierTable();
      if (!table) return [];

      var rows = table.querySelectorAll('tbody tr, .tdf_wholesale_level');
      if (!rows.length) return [];

      var parsed = [];

      rows.forEach(function (row) {
        var minQty = NaN;
        if (row.hasAttribute('data-q')) {
          minQty = parseInt(row.getAttribute('data-q'), 10);
        }
        if (isNaN(minQty)) {
          var firstCell = row.querySelector('td');
          minQty = parseTierMinQuantity(firstCell ? firstCell.textContent : row.textContent);
        }
        if (!Number.isFinite(minQty) || minQty < 1) return;

        var eachCents = parseAiodEachCentsFromRow(row, fallbackBasePriceCents);
        if (!Number.isFinite(eachCents) || eachCents <= 0) return;

        parsed.push({
          minimum_quantity: minQty,
          price: eachCents
        });
      });

      parsed.sort(function (a, b) {
        return a.minimum_quantity - b.minimum_quantity;
      });

      var deduped = [];
      parsed.forEach(function (entry) {
        var last = deduped[deduped.length - 1];
        if (last && last.minimum_quantity === entry.minimum_quantity) {
          deduped[deduped.length - 1] = entry;
        } else {
          deduped.push(entry);
        }
      });

      return deduped;
    };

    var getTierBreaksForVariant = function (variant) {
      if (!variant) return [];

      var nativeBreaks = Array.isArray(variant.quantity_price_breaks) ? variant.quantity_price_breaks : [];
      if (nativeBreaks.length) {
        return nativeBreaks
          .map(function (br) {
            return {
              minimum_quantity: parseInt(br.minimum_quantity, 10),
              price: parseInt(br.price, 10)
            };
          })
          .filter(function (br) {
            return Number.isFinite(br.minimum_quantity) && br.minimum_quantity > 0 && Number.isFinite(br.price) && br.price > 0;
          })
          .sort(function (a, b) {
            return a.minimum_quantity - b.minimum_quantity;
          });
      }

      return getAiodTierBreaks(parseInt(variant.price, 10) || 0);
    };

    var toggleExternalTierBlock = function (hideExternal) {
      if (!isDefaultCustomTemplate) return;
      // Keep AIOD tables visible by default; only hide if explicitly enabled.
      if (hideExternal && String(root.dataset.hideExternalTiers || '').toLowerCase() !== 'true') {
        hideExternal = false;
      }
      var infoContainer = root.closest('.product__info-container') || root.closest('.product__info-wrapper') || root;
      if (!infoContainer) return;

      var aiodWrap = infoContainer.querySelector('.aiod-volume-discount-wrap');
      var targetScope = aiodWrap || infoContainer;

      targetScope.querySelectorAll('.csapps-volume-discount-tiers, .heading_table, .discount-label-conatiner').forEach(function (el) {
        if (!aiodWrap) {
          var insideCardLikeContext = el.closest('.card-wrapper, .card-product, .product-card-wrapper, .complementary-products');
          if (insideCardLikeContext) return;
        }
        el.style.display = hideExternal ? 'none' : '';
      });
    };

    var isElementVisible = function (element) {
      if (!element) return false;
      var style = window.getComputedStyle(element);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      return !!(element.offsetParent || (element.getClientRects && element.getClientRects().length));
    };

    var getAiodUnitPriceForQuantity = function (quantity, fallbackBasePriceCents) {
      var qty = parseInt(quantity, 10) || 1;
      var breaks = getAiodTierBreaks(fallbackBasePriceCents);
      if (!breaks.length) return NaN;
      var bestMinQty = -1;
      var bestEachCents = NaN;

      breaks.forEach(function (br) {
        if (qty >= br.minimum_quantity && br.minimum_quantity >= bestMinQty) {
          bestMinQty = br.minimum_quantity;
          bestEachCents = br.price;
        }
      });

      return Number.isFinite(bestEachCents) ? bestEachCents : NaN;
    };

    var getAiodPercentOffForQuantity = function (quantity, fallbackBasePriceCents) {
      var qty = parseInt(quantity, 10) || 1;
      var breaks = getAiodPercentBreaks(fallbackBasePriceCents);
      if (!breaks.length) return 0;

      var bestPercentOff = 0;
      var bestMinQty = -1;

      breaks.forEach(function (br) {
        if (qty >= br.minimum_quantity && br.minimum_quantity >= bestMinQty) {
          bestMinQty = br.minimum_quantity;
          bestPercentOff = br.percent_off;
        }
      });

      return Number.isFinite(bestPercentOff) ? bestPercentOff : 0;
    };

    var getUnitPriceForQuantity = function (variant, quantity) {
      if (!variant) return 0;

      var baseVariantPrice = parseInt(variant.price, 10) || 0;
      var unitPrice = baseVariantPrice;
      var qty = parseInt(quantity, 10) || 1;
      var breaks = Array.isArray(variant.quantity_price_breaks) ? variant.quantity_price_breaks : [];

      breaks.forEach(function (br) {
        if (!br) return;
        var minQty = parseInt(br.minimum_quantity, 10);
        var breakPrice = parseInt(br.price, 10);
        if (isNaN(minQty) || isNaN(breakPrice)) return;
        if (qty >= minQty) {
          unitPrice = breakPrice;
        }
      });

      var aiodTierUnitPrice = getAiodUnitPriceForQuantity(qty, baseVariantPrice);
      if (Number.isFinite(aiodTierUnitPrice) && aiodTierUnitPrice > 0) {
        unitPrice = aiodTierUnitPrice;
      }

      return unitPrice;
    };

    var getCustomUnitPriceForQuantity = function (customUnitPriceCents, quantity, variant) {
      var baseCustom = parseInt(customUnitPriceCents, 10);
      if (!Number.isFinite(baseCustom) || baseCustom <= 0) return NaN;

      var fallbackBase = variant ? (parseInt(variant.price, 10) || 0) : 0;
      var percentOff = getAiodPercentOffForQuantity(quantity, fallbackBase);
      if (!Number.isFinite(percentOff) || percentOff <= 0) return baseCustom;

      var discountCents = Math.floor((baseCustom * (percentOff / 100)) + Number.EPSILON);
      return Math.max(0, baseCustom - discountCents);
    };

    var getExtrasTotal = function () {
      var total = 0;
      extraInputs.forEach(function (input) {
        if (!input.checked) return;
        var price = parseInt(input.dataset.price, 10) || 0;
        var perItem = input.dataset.perItem === 'true';
        total += perItem ? price * getQuantity() : price;
      });
      extraGroups.forEach(function (group) {
        var selected = group.querySelector('[data-extra-option-button].active');
        if (!selected) return;
        var price = parseInt(selected.dataset.price, 10) || 0;
        var perItem = selected.dataset.perItem === 'true';
        total += perItem ? price * getQuantity() : price;
      });
      return total;
    };

    var collectAddonSelections = function () {
      var selections = [];

      extraInputs.forEach(function (extra) {
        if (!extra.checked) return;

        var item = extra.closest('.extra-item');
        var label = 'Extra';
        if (item) {
          var labelNode = item.querySelector('label');
          if (labelNode) label = labelNode.textContent.trim();
        }

        selections.push({
          type: 'checkbox',
          label: label,
          price: parseInt(extra.dataset.price, 10) || 0,
          per_item: extra.dataset.perItem === 'true'
        });
      });

      extraGroups.forEach(function (group) {
        var selected = group.querySelector('[data-extra-option-button].active');
        if (!selected) return;

        selections.push({
          type: 'group',
          group: group.dataset.groupLabel || 'Option',
          label: selected.dataset.label || '',
          value_key: selected.dataset.valueKey || '',
          price: parseInt(selected.dataset.price, 10) || 0,
          per_item: selected.dataset.perItem === 'true'
        });
      });

      return selections;
    };

    var normalizeLabelText = function (value) {
      return (value || '').replace(/\s+/g, ' ').trim();
    };

    var getSelectedVariantOptionRows = function (excludedOptionNames) {
      var rows = [];
      var excluded = {};
      (excludedOptionNames || []).forEach(function (name) {
        excluded[String(name || '').toLowerCase()] = true;
      });

      if (!data.options || !optionSelects) return rows;
      for (var i = 0; i < optionSelects.length; i++) {
        var optionName = data.options[i] || 'Option ' + String(i + 1);
        if (excluded[String(optionName).toLowerCase()]) continue;

        var optionValue = optionSelects[i] ? normalizeLabelText(optionSelects[i].value) : '';
        if (!optionValue) continue;

        rows.push({ name: optionName, value: optionValue });
      }

      return rows;
    };

    var getSelectedAddonRows = function (excludeFinishGroup) {
      var rows = [];

      extraInputs.forEach(function (extra) {
        if (!extra.checked) return;

        var item = extra.closest('.extra-item');
        var name = 'Extra';
        if (item) {
          var labelNode = item.querySelector('label');
          if (labelNode) name = normalizeLabelText(labelNode.textContent);
        }

        var price = parseInt(extra.dataset.price, 10) || 0;
        var perItem = extra.dataset.perItem === 'true';
        var value = price > 0 ? '+' + formatMoney(price, moneyFormat) + (perItem ? ' each' : '') : 'Included';

        rows.push({ name: name, value: value });
      });

      extraGroups.forEach(function (group) {
        if (excludeFinishGroup && (group.dataset.groupStyle || '').toLowerCase() === 'finish') return;

        var selected = group.querySelector('[data-extra-option-button].active');
        if (!selected) return;

        var groupName = normalizeLabelText(group.dataset.groupLabel || 'Option');
        var selectedLabel = normalizeLabelText(selected.dataset.label || '');
        if (!selectedLabel) return;

        var price = parseInt(selected.dataset.price, 10) || 0;
        var perItem = selected.dataset.perItem === 'true';
        if (price > 0) {
          selectedLabel += ' (+' + formatMoney(price, moneyFormat) + (perItem ? ' each' : '') + ')';
        }

        rows.push({ name: groupName, value: selectedLabel });
      });

      return rows;
    };

    var renderModalSelectionRows = function (summaryContainer, listContainer, rows) {
      if (!summaryContainer || !listContainer) return;
      listContainer.innerHTML = '';

      if (!rows || !rows.length) {
        summaryContainer.hidden = true;
        return;
      }

      rows.forEach(function (row) {
        var item = document.createElement('div');
        item.className = 'modal-selection-item';

        var nameEl = document.createElement('span');
        nameEl.className = 'modal-selection-name';
        nameEl.textContent = row.name || 'Option';

        var valueEl = document.createElement('span');
        valueEl.className = 'modal-selection-value';
        valueEl.textContent = row.value || '';

        item.appendChild(nameEl);
        item.appendChild(valueEl);
        listContainer.appendChild(item);
      });

      summaryContainer.hidden = false;
    };

    var renderDfmInlineRows = function (container, listContainer, rows) {
      if (!container || !listContainer) return;
      listContainer.innerHTML = '';

      if (!rows || !rows.length) {
        container.hidden = true;
        return;
      }

      rows.forEach(function (row) {
        var item = document.createElement('div');
        item.className = 'dfm-sum-row';

        var nameEl = document.createElement('span');
        nameEl.textContent = row.name || 'Option';

        var valueEl = document.createElement('span');
        valueEl.textContent = row.value || '';

        item.appendChild(nameEl);
        item.appendChild(valueEl);
        listContainer.appendChild(item);
      });

      container.hidden = false;
    };

    var updateModalSelectionSummaries = function () {
      var uploadRows = getSelectedVariantOptionRows(['size', 'orientation']).concat(getSelectedAddonRows(false));
      var dfmRows = getSelectedVariantOptionRows(['size', 'orientation']).concat(getSelectedAddonRows(true));

      renderModalSelectionRows(uploadSelectionSummary, uploadSelectionList, uploadRows);
      renderDfmInlineRows(dfmExtraOptions, dfmExtraOptionsList, dfmRows);
    };

    var getOptionImageUrl = function (optionIndex) {
      var key = String(optionIndex + 1);
      if (currentVariant && currentVariant.option_images && currentVariant.option_images[key]) {
        return currentVariant.option_images[key];
      }

      if (!optionSelects[optionIndex]) return '';
      var selectedValue = optionSelects[optionIndex].value;
      if (!selectedValue) return '';

      if (optionImageLookup[key] && optionImageLookup[key][selectedValue]) {
        return optionImageLookup[key][selectedValue];
      }

      return '';
    };

    var updateOptionPreviews = function () {
      optionPreviews.forEach(function (preview) {
        var optionIndex = parseInt(preview.dataset.optionPreviewIndex, 10);
        if (isNaN(optionIndex) || optionIndex < 0) return;

        var image = preview.querySelector('[data-option-preview-image]');
        if (!image) return;

        var imageUrl = getOptionImageUrl(optionIndex);

        if (imageUrl) {
          if (image.getAttribute('src') !== imageUrl) {
            image.setAttribute('src', imageUrl);
          }
          var optionName = data.options && data.options[optionIndex] ? data.options[optionIndex] : 'Option';
          var optionValue = optionSelects[optionIndex] ? optionSelects[optionIndex].value : '';
          image.setAttribute('alt', optionName + ': ' + optionValue);
          preview.hidden = false;
          preview.classList.add('show');
        } else {
          image.removeAttribute('src');
          image.setAttribute('alt', '');
          preview.hidden = true;
          preview.classList.remove('show');
        }
      });
    };

    var updateOptionLabels = function () {
      optionSelects.forEach(function (select, index) {
        if (optionLabels[index]) {
          optionLabels[index].textContent = select.value;
        }
      });
    };

    var updatePills = function () {
      pills.forEach(function (pill) {
        var index = parseInt(pill.dataset.optionIndex, 10);
        var value = pill.dataset.optionValue;
        var isActive = optionSelects[index] && optionSelects[index].value === value;
        pill.classList.toggle('active', isActive);
      });
    };

    var updateCustomDims = function () {
      if (!customDims || !sizeSelect) return;
      var isCustom = isCustomSizeSelected();
      customDims.classList.toggle('show', isCustom);
      updateCustomDimsFeedback();
    };

    var updateTierStrip = function (variant) {
      if (!tierStrip) return;
      tierStrip.innerHTML = '';
      if (isCustomSizeSelected()) {
        var customValidation = getCustomDimensionsValidation();
        var customUnitCents = getCustomUnitPriceCents(customValidation);
        var fallbackBase = variant ? (parseInt(variant.price, 10) || 0) : 0;
        var customPercentBreaks = getAiodPercentBreaks(fallbackBase);

        if (!Number.isFinite(customUnitCents) || customUnitCents <= 0 || !customPercentBreaks.length) {
          activeTierBreaks = [];
          toggleExternalTierBlock(false);
          return;
        }

        activeTierBreaks = customPercentBreaks.map(function (br) {
          return {
            minimum_quantity: br.minimum_quantity,
            price: getCustomUnitPriceForQuantity(customUnitCents, br.minimum_quantity, variant)
          };
        }).filter(function (br) {
          return Number.isFinite(br.price) && br.price > 0;
        });

        if (!activeTierBreaks.length) {
          toggleExternalTierBlock(false);
          return;
        }

        toggleExternalTierBlock(true);

        activeTierBreaks.forEach(function (br) {
          var pill = document.createElement('div');
          pill.className = 'tier-pill';
          pill.dataset.qty = br.minimum_quantity;
          var qtyLabel = br.minimum_quantity === 1 ? '1' : br.minimum_quantity + '+';
          pill.innerHTML =
            '<div class="tp-qty">' +
            qtyLabel +
            '</div><div class="tp-each">' +
            formatMoney(br.price, moneyFormat) +
            '</div>';
          pill.addEventListener('click', function () {
            qtyInput.value = br.minimum_quantity;
            updateAll();
          });
          tierStrip.appendChild(pill);
        });
        return;
      }
      activeTierBreaks = getTierBreaksForVariant(variant);
      if (!activeTierBreaks.length) {
        toggleExternalTierBlock(false);
        return;
      }
      toggleExternalTierBlock(true);

      activeTierBreaks.forEach(function (br) {
        var pill = document.createElement('div');
        pill.className = 'tier-pill';
        pill.dataset.qty = br.minimum_quantity;
        var qtyLabel = br.minimum_quantity === 1 ? '1' : br.minimum_quantity + '+';
        pill.innerHTML =
          '<div class="tp-qty">' +
          qtyLabel +
          '</div><div class="tp-each">' +
          formatMoney(br.price, moneyFormat) +
          '</div>';
        pill.addEventListener('click', function () {
          qtyInput.value = br.minimum_quantity;
          updateAll();
        });
        tierStrip.appendChild(pill);
      });
    };

    var highlightTier = function (variant) {
      if (!tierStrip) return;
      if (isCustomSizeSelected()) {
        tierStrip.querySelectorAll('.tier-pill.active').forEach(function (pill) {
          pill.classList.remove('active');
        });
        return;
      }
      if (!activeTierBreaks.length) {
        activeTierBreaks = getTierBreaksForVariant(variant);
      }
      if (!activeTierBreaks.length) return;

      var qty = getQuantity();
      var activeBreak = null;
      activeTierBreaks.forEach(function (br) {
        if (qty >= br.minimum_quantity) {
          activeBreak = br.minimum_quantity;
        }
      });
      tierStrip.querySelectorAll('.tier-pill').forEach(function (pill) {
        pill.classList.toggle('active', parseInt(pill.dataset.qty, 10) === activeBreak);
      });
    };

    var updateQuantityRules = function (variant) {
      if (!variant || !variant.quantity_rule) return;
      if (variant.quantity_rule.min) qtyInput.min = variant.quantity_rule.min;
      if (variant.quantity_rule.max) qtyInput.max = variant.quantity_rule.max;
      if (variant.quantity_rule.increment) qtyInput.step = variant.quantity_rule.increment;
    };

    var updateDFMSummary = function () {
      if (!currentVariant) return;

      var qty = getQuantity();
      var customValidation = getCustomDimensionsValidation();
      updateCustomDimsFeedback(customValidation);
      var unitPrice = getActiveUnitPriceForQuantity(currentVariant, qty);
      var hasCustomError = customValidation.active && !customValidation.valid;
      if (customValidation.active && hasCustomError) unitPrice = NaN;
      var subtotal = unitPrice * qty + getExtrasTotal();
      var grand = subtotal + dfmFeeCents;

      if (dfmChoicePriceBanner) {
        dfmChoicePriceBanner.textContent = Number.isFinite(grand) ? formatMoney(grand, moneyFormat) : '--';
      }
      if (dfmSize) dfmSize.textContent = getVariantLabel();
      if (dfmSizePrice) dfmSizePrice.textContent = Number.isFinite(unitPrice) ? formatMoney(unitPrice, moneyFormat) + ' each' : '--';
      if (dfmFinish) dfmFinish.textContent = getSelectedFinishLabel();
      if (dfmQtyLabel) dfmQtyLabel.textContent = qty + (qty === 1 ? ' item' : ' items');
      if (dfmSubtotal) dfmSubtotal.textContent = Number.isFinite(subtotal) ? formatMoney(subtotal, moneyFormat) : '--';
      if (dfmTotal) dfmTotal.textContent = Number.isFinite(grand) ? formatMoney(grand, moneyFormat) : '--';

      if (dfmSummary) {
        dfmSummary.style.display = dfmChoice === 'banner' ? 'block' : 'none';
      }

      if (dfmSubmitPrefix) {
        dfmSubmitPrefix.textContent = dfmChoice === 'banner' ? 'Add to Cart - ' : 'Purchase Design - ';
      }

      if (dfmSubmitTotal) {
        if (dfmChoice === 'banner') {
          dfmSubmitTotal.textContent = Number.isFinite(grand) ? formatMoney(grand, moneyFormat) : '--';
        } else {
          dfmSubmitTotal.textContent = formatMoney(dfmFeeCents, moneyFormat);
        }
      }

      dfmChoiceCards.forEach(function (card) {
        card.classList.toggle('selected', card.dataset.dfmChoiceCard === dfmChoice);
      });
    };

    var updatePricing = function () {
      if (!currentVariant) {
        totalPrice.textContent = '--';
        unitLine.textContent = '';
        if (uploadSize) uploadSize.textContent = '--';
        if (uploadOrientation) uploadOrientation.textContent = '--';
        updateModalSelectionSummaries();
        return;
      }

      var qty = getQuantity();
      var customValidation = getCustomDimensionsValidation();
      updateCustomDimsFeedback(customValidation);
      var hasCustomError = customValidation.active && !customValidation.valid;
      var basePrice = hasCustomError ? NaN : getActiveUnitPriceForQuantity(currentVariant, qty);
      var total = basePrice * qty + getExtrasTotal();

      totalPrice.textContent = Number.isFinite(total) ? formatMoney(total, moneyFormat) : '--';
      if (Number.isFinite(basePrice) && qty > 1) {
        unitLine.textContent = qty + ' x ' + formatMoney(basePrice, moneyFormat) + ' ea';
      } else if (hasCustomError) {
        unitLine.textContent = customValidation.message || 'Enter custom dimensions';
      } else {
        unitLine.textContent = '';
      }
      qtyLabel.textContent = qty + (qty === 1 ? ' item' : ' items');

      if (uploadSize) uploadSize.textContent = getOptionValueByName('size') || getVariantLabel();
      if (uploadOrientation) uploadOrientation.textContent = getOptionValueByName('orientation') || '--';
      if (uploadQty) uploadQty.textContent = qty;
      if (uploadTotal) uploadTotal.textContent = Number.isFinite(total) ? formatMoney(total, moneyFormat) : '--';
      updateModalSelectionSummaries();

      highlightTier(currentVariant);
      updateDFMSummary();
    };

    var updateDesignButton = function (variant) {
      if (!designButton) return;
      var customValidation = getCustomDimensionsValidation();
      var hasCustomError = customValidation.active && !customValidation.valid;
      if (!variant || !variant.available || hasCustomError) {
        designButton.setAttribute('disabled', 'disabled');
        return;
      }
      designButton.removeAttribute('disabled');
      designButton.dataset.variantId = variant.id;
      designButton.dataset.variantSku = variant.sku || '';
    };

    var updateAll = function () {
      updateOptionLabels();
      updatePills();
      normalizeCustomDimensionsForOrientation();
      applyCustomDimensionInputLimits();
      updateCustomDims();
      currentVariant = findVariant();
      updateOptionPreviews();
      updateTierStrip(currentVariant);
      updateQuantityRules(currentVariant);
      updatePricing();
      updateDesignButton(currentVariant);
      syncVariantToProductForms(currentVariant);
    };

    var scheduleTierSync = function () {
      if (tierSyncTimer) window.clearTimeout(tierSyncTimer);
      tierSyncTimer = window.setTimeout(function () {
        if (!currentVariant) return;
        updateTierStrip(currentVariant);
        updatePricing();
      }, 120);
    };

    var syncVariantToProductForms = function (variant) {
      if (!productFormId) return;

      var formElement = document.getElementById(productFormId);
      var inputs = [];
      if (formElement) {
        inputs = inputs.concat(Array.prototype.slice.call(formElement.querySelectorAll('[name="id"]')));
      }

      var linkedInputs = document.querySelectorAll('[name="id"][form="' + productFormId + '"]');
      inputs = inputs.concat(Array.prototype.slice.call(linkedInputs));

      if (!inputs.length) return;

      if (!variant) {
        inputs.forEach(function (input) {
          input.disabled = true;
        });
        return;
      }

      var customValidation = getCustomDimensionsValidation();
      var hasCustomError = customValidation.active && !customValidation.valid;

      inputs.forEach(function (input) {
        input.value = variant.id;
        input.disabled = !variant.available || hasCustomError;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    };

    var syncExtraPropertiesToForm = function (selections) {
      if (!addonPropertiesContainer) return;

      addonPropertiesContainer.innerHTML = '';
      if (!productFormId) return;

      var rows = [];
      (selections || []).forEach(function (selection) {
        rows.push({ type: 'addon', selection: selection });
      });
      getCustomSizeProperties().forEach(function (property) {
        rows.push({ type: 'custom', property: property });
      });

      if (!rows.length) return;
      rows.forEach(function (row) {
        var input = document.createElement('input');
        input.type = 'hidden';
        input.setAttribute('form', productFormId);
        input.className = 'custom-addon-property';

        if (row.type === 'addon') {
          var selection = row.selection;
          if (selection.type === 'group') {
            var groupName = selection.group || 'Option';
            var groupValue = selection.label || '';
            if (selection.price > 0) {
              groupValue += ' (' + formatMoney(selection.price, moneyFormat) + (selection.per_item ? ' each' : '') + ')';
            }
            input.name = 'properties[' + groupName + ']';
            input.value = groupValue;
          } else {
            var extraLabel = selection.label || 'Extra';
            var extraValue = 'Yes';
            if (selection.price > 0) {
              extraValue = formatMoney(selection.price, moneyFormat) + (selection.per_item ? ' each' : '');
            }
            input.name = 'properties[' + extraLabel + ']';
            input.value = extraValue;
          }
        } else {
          input.name = 'properties[' + row.property.name + ']';
          input.value = row.property.value;
        }

        addonPropertiesContainer.appendChild(input);
      });
    };

    var storeExtrasSelection = function () {
      var selections = collectAddonSelections();
      sessionStorage.setItem('productAddons', JSON.stringify(selections));
      syncExtraPropertiesToForm(selections);
    };

    var getAddonPropertyObject = function () {
      var properties = {};
      var selections = collectAddonSelections();

      selections.forEach(function (selection) {
        if (selection.type === 'group') {
          var groupName = selection.group || 'Option';
          var groupValue = selection.label || '';
          if (selection.price > 0) {
            groupValue += ' (' + formatMoney(selection.price, moneyFormat) + (selection.per_item ? ' each' : '') + ')';
          }
          properties[groupName] = groupValue;
        } else {
          var extraLabel = selection.label || 'Extra';
          var extraValue = selection.price > 0
            ? formatMoney(selection.price, moneyFormat) + (selection.per_item ? ' each' : '')
            : 'Yes';
          properties[extraLabel] = extraValue;
        }
      });

      getCustomSizeProperties().forEach(function (property) {
        properties[property.name] = property.value;
      });

      return properties;
    };

    var addCartItemJson = async function (payload) {
      var response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        var errorData = null;
        try {
          errorData = await response.json();
        } catch (err) {
          errorData = null;
        }
        var message = errorData && errorData.description ? errorData.description : 'Unable to add item to cart.';
        throw new Error(message);
      }

      return response.json();
    };

    var closeAllVsel = function () {
      root.querySelectorAll('[data-vsel].open').forEach(function (openSel) {
        openSel.classList.remove('open');
      });
      root.querySelectorAll('.cfg.vsel-open').forEach(function (cfg) {
        cfg.classList.remove('vsel-open');
      });
    };

    var openModal = function (modal) {
      if (!modal) return;
      modal.classList.add('open');
      document.body.style.overflow = 'hidden';
    };

    var closeModal = function (modal) {
      if (!modal) return;
      modal.classList.remove('open');
      if (!document.querySelector('.modal-overlay.open[data-modal-section]')) {
        document.body.style.overflow = '';
      }
    };

    var resetUpload = function () {
      selectedFile = null;
      if (uploadZone) uploadZone.classList.remove('has-file');
      if (uploadZoneDefault) uploadZoneDefault.style.display = 'block';
      if (uploadZoneFile) uploadZoneFile.style.display = 'none';
      if (uploadFileInput) uploadFileInput.value = '';
      if (uploadError) uploadError.style.display = 'none';
      if (uploadSaveBtn) uploadSaveBtn.disabled = true;
      if (uploadSaveText) uploadSaveText.textContent = 'Upload a file to continue';
    };

    var formatBytes = function (bytes) {
      if (bytes < 1048576) return (bytes / 1024).toFixed(0) + ' KB';
      return (bytes / 1048576).toFixed(1) + ' MB';
    };

    var getExtLabel = function (file) {
      var parts = file.name.split('.');
      return (parts[parts.length - 1] || 'FILE').toUpperCase();
    };

    var processFile = function (file) {
      if (!file) return;

      if (file.size > MAX_BYTES) {
        if (uploadErrorMsg) {
          uploadErrorMsg.textContent = 'File too large (' + formatBytes(file.size) + '). Max 25 MB.';
        }
        if (uploadError) uploadError.style.display = 'flex';
        return;
      }

      if (uploadError) uploadError.style.display = 'none';
      selectedFile = file;

      if (uploadZone) uploadZone.classList.add('has-file');
      if (uploadZoneDefault) uploadZoneDefault.style.display = 'none';
      if (uploadZoneFile) uploadZoneFile.style.display = 'flex';
      if (uploadFileName) uploadFileName.textContent = file.name;
      if (uploadFileMeta) uploadFileMeta.textContent = getExtLabel(file) + ' - ' + formatBytes(file.size);
      if (uploadSaveBtn) uploadSaveBtn.disabled = false;
      if (uploadSaveText) uploadSaveText.textContent = 'Add to Cart - Artwork Ready';
    };

    applyCustomDimensionInputLimits();

    optionSelects.forEach(function (select) {
      select.addEventListener('change', updateAll);
    });

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        var index = parseInt(pill.dataset.optionIndex, 10);
        var value = pill.dataset.optionValue;
        if (optionSelects[index]) {
          optionSelects[index].value = value;
          updateAll();
        }
      });
    });

    extraInputs.forEach(function (input) {
      input.addEventListener('change', function () {
        storeExtrasSelection();
        updatePricing();
      });
    });

    if (qtyMinus) {
      qtyMinus.addEventListener('click', function () {
        var qty = getQuantity();
        var min = parseInt(qtyInput.min, 10) || 1;
        qtyInput.value = Math.max(min, qty - 1);
        updatePricing();
      });
    }

    if (qtyPlus) {
      qtyPlus.addEventListener('click', function () {
        var qty = getQuantity();
        var max = parseInt(qtyInput.max, 10) || 0;
        var next = qty + 1;
        if (max && next > max) next = max;
        qtyInput.value = next;
        updatePricing();
      });
    }

    if (qtyInput) {
      qtyInput.addEventListener('change', function () {
        var qty = getQuantity();
        var min = parseInt(qtyInput.min, 10) || 1;
        var max = parseInt(qtyInput.max, 10) || 0;
        if (qty < min) qty = min;
        if (max && qty > max) qty = max;
        qtyInput.value = qty;
        updatePricing();
      });
    }

    [customWidthInput, customHeightInput].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', function () {
        updateAll();
        storeExtrasSelection();
      });
      input.addEventListener('change', function () {
        updateAll();
        storeExtrasSelection();
      });
    });

    vselTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();

        var vsel = trigger.closest('[data-vsel]');
        if (!vsel) return;

        var parentCfg = vsel.closest('.cfg');
        var isOpening = !vsel.classList.contains('open');

        closeAllVsel();

        if (isOpening) {
          vsel.classList.add('open');
          if (parentCfg) parentCfg.classList.add('vsel-open');
        }
      });
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target) || !event.target.closest('[data-vsel]')) {
        closeAllVsel();
      }
    });

    extraOptionButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-extra-group]');
        if (!group) return;

        group.querySelectorAll('[data-extra-option-button]').forEach(function (opt) {
          opt.classList.remove('active');
        });
        btn.classList.add('active');

        var labelTarget = group.querySelector('[data-group-current]');
        if (labelTarget) labelTarget.textContent = btn.dataset.label || '';

        var triggerText = group.querySelector('[data-vsel-trigger-text]');
        if (triggerText) {
          var price = parseInt(btn.dataset.price, 10) || 0;
          var perItem = btn.dataset.perItem === 'true';
          var priceText = price > 0 ? formatMoney(price, moneyFormat) + (perItem ? ' each' : '') : 'No extra charge';
          triggerText.textContent = (btn.dataset.label || '') + ' (' + priceText + ')';
        }

        var preview = group.querySelector('[data-vsel-preview]');
        var vis = btn.querySelector('[data-vopt-vis]');
        if (preview && vis) {
          preview.innerHTML = vis.outerHTML;
          var previewVis = preview.querySelector('[data-vopt-vis]');
          if (previewVis) {
            previewVis.classList.add('is-active');
          }
        }

        closeAllVsel();
        storeExtrasSelection();
        updatePricing();
      });
    });

    if (uploadButton && uploadModal) {
      uploadButton.addEventListener('click', function () {
        if (uploadFormContent) uploadFormContent.style.display = 'block';
        if (uploadFooter) uploadFooter.style.display = 'block';
        if (uploadSuccess) uploadSuccess.classList.remove('show');
        openModal(uploadModal);
      });
    }

    if (dfmButton && dfmModal) {
      dfmButton.addEventListener('click', function () {
        dfmChoice = 'banner';
        if (dfmFormContent) dfmFormContent.style.display = 'block';
        if (dfmSuccess) dfmSuccess.classList.remove('show');
        updateDFMSummary();
        openModal(dfmModal);
      });
    }

    modalOverlays.forEach(function (overlay) {
      overlay.querySelectorAll('[data-modal-close]').forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          var target = event.currentTarget.dataset.modalClose;
          modalOverlays.forEach(function (modal) {
            if (modal.dataset.modalId === target) {
              closeModal(modal);
            }
          });
        });
      });

      overlay.addEventListener('click', function (event) {
        if (event.target === overlay) {
          closeModal(overlay);
        }
      });
    });

    if (uploadZone) {
      uploadZone.addEventListener('dragover', function (event) {
        event.preventDefault();
        uploadZone.classList.add('drag-over');
      });

      uploadZone.addEventListener('dragleave', function () {
        uploadZone.classList.remove('drag-over');
      });

      uploadZone.addEventListener('drop', function (event) {
        event.preventDefault();
        uploadZone.classList.remove('drag-over');
        if (event.dataTransfer.files && event.dataTransfer.files.length) {
          processFile(event.dataTransfer.files[0]);
        }
      });

      uploadZone.addEventListener('click', function () {
        if (uploadFileInput) uploadFileInput.click();
      });
    }

    if (uploadFileInput) {
      uploadFileInput.addEventListener('change', function () {
        if (uploadFileInput.files && uploadFileInput.files.length) {
          processFile(uploadFileInput.files[0]);
        }
      });
    }

    if (uploadModal) {
      uploadModal.querySelectorAll('[data-upload-remove]').forEach(function (btn) {
        btn.addEventListener('click', function (event) {
          event.stopPropagation();
          resetUpload();
        });
      });
    }

    if (uploadSaveBtn) {
      uploadSaveBtn.addEventListener('click', function () {
        if (!selectedFile) return;
        if (uploadFormContent) uploadFormContent.style.display = 'none';
        if (uploadFooter) uploadFooter.style.display = 'none';
        if (uploadSuccess) uploadSuccess.classList.add('show');
      });
    }

    dfmChoiceCards.forEach(function (card) {
      card.addEventListener('click', function () {
        dfmChoice = card.dataset.dfmChoiceCard === 'design' ? 'design' : 'banner';
        updateDFMSummary();
      });
    });

    if (dfmSubmit) {
      dfmSubmit.addEventListener('click', async function () {
        if (dfmDesc && !dfmDesc.value.trim()) {
          dfmDesc.focus();
          dfmDesc.style.borderColor = '#c8102e';
          return;
        }

        if (!designFeeVariantId || isNaN(parseInt(designFeeVariantId, 10))) {
          alert('Design fee product is not configured. Please contact support.');
          return;
        }

        if (dfmSubmit.disabled) return;
        dfmSubmit.disabled = true;

        try {
          var designBrief = dfmDesc ? dfmDesc.value.trim() : '';
          var designFiles = dfmFiles ? dfmFiles.value.trim() : '';
          var selectedOptionRows = getSelectedVariantOptionRows([]);
          var addonProperties = getAddonPropertyObject();
          var feeProperties = {
            'Design Request': dfmChoice === 'design' ? 'Design Service Only' : 'Banner + Design Service',
            'Design Brief': designBrief
          };

          if (designFiles) {
            feeProperties['Reference Files'] = designFiles;
          }

          selectedOptionRows.forEach(function (row) {
            feeProperties[row.name] = row.value;
          });

          Object.keys(addonProperties).forEach(function (key) {
            if (!(key in feeProperties)) {
              feeProperties[key] = addonProperties[key];
            } else {
              feeProperties['Add-on ' + key] = addonProperties[key];
            }
          });

          if (dfmChoice === 'design') {
            await addCartItemJson({
              id: parseInt(designFeeVariantId, 10),
              quantity: 1,
              properties: Object.assign({}, feeProperties, {
                _is_design_fee: 'true',
                _design_only: 'true'
              })
            });
          } else {
            if (!currentVariant || !currentVariant.available) {
              throw new Error('Selected option is unavailable.');
            }

            var qty = getQuantity();
            var bannerItem = await addCartItemJson({
              id: currentVariant.id,
              quantity: qty
            });

            await addCartItemJson({
              id: parseInt(designFeeVariantId, 10),
              quantity: 1,
              properties: Object.assign({}, feeProperties, {
                _is_design_fee: 'true',
                _linked_to: bannerItem.key
              })
            });
          }

          window.location.href = '/cart';
        } catch (error) {
          alert(error && error.message ? error.message : 'There was an error adding to cart. Please try again.');
        } finally {
          dfmSubmit.disabled = false;
        }
      });
    }

    if (dfmDesc) {
      dfmDesc.addEventListener('input', function () {
        dfmDesc.style.borderColor = '';
      });
    }

    if (designButton) {
      designButton.addEventListener('click', function (event) {
        event.preventDefault();
        if (!currentVariant) return;

        var designHuddleEnabled = root.dataset.designHuddle === 'true';
        if (!designHuddleEnabled || typeof DSHDLib === 'undefined') return;

        var templateCode = root.dataset.designHuddleTemplate || currentVariant.sku;
        var quantity = getQuantity();

        DSHDLib.configure({
          domain: 'victorystore.designhuddle.com',
          client_id: 'ynl5e3ud6suegolovve3',
          guest: true
        });

        DSHDLib.createProject({ template_code: templateCode }, function (error, dataResponse) {
          if (error) {
            alert('There was an error starting the editor. Please try again.');
            return;
          }

          var projectId = dataResponse.project_id || '';
          var editorUrl =
            '/pages/custom-design-editor?item_code=' +
            encodeURIComponent(templateCode) +
            '&item_handle=' +
            encodeURIComponent(root.dataset.productHandle || '') +
            '&quantity=' +
            quantity +
            '&item_id=' +
            currentVariant.id +
            '&project_id=' +
            projectId +
            '&template_id=' +
            encodeURIComponent(templateCode);

          window.location.href = editorUrl;
        });
      });
    }

    if (browseTemplates) {
      browseTemplates.addEventListener('click', function (event) {
        if (!browseTemplates.href || browseTemplates.href === '#') {
          event.preventDefault();
        }
      });
    }

    if (isDefaultCustomTemplate) {
      var tierObserverScope = root.closest('.product__info-wrapper') || root;
      if (tierObserverScope) {
        new MutationObserver(function (mutations) {
          var hasAiodMutation = mutations.some(function (mutation) {
            var targetEl = mutation.target && mutation.target.nodeType === 1 ? mutation.target : null;
            if (!targetEl || root.contains(targetEl)) return false;

            if (targetEl.closest('.csapps-volume-discount-tiers, .aiod-volume-discount-wrap, #tdf_wholesale')) {
              return true;
            }

            var changedNodes = Array.prototype.slice.call(mutation.addedNodes || []).concat(Array.prototype.slice.call(mutation.removedNodes || []));
            return changedNodes.some(function (node) {
              if (!node || node.nodeType !== 1) return false;
              if (node.matches && node.matches('.csapps-volume-discount-tiers, .aiod-volume-discount-wrap, #tdf_wholesale, table.csapps-table, .tdf_wholesale_level')) {
                return true;
              }
              return !!(node.querySelector && node.querySelector('.csapps-volume-discount-tiers, .aiod-volume-discount-wrap, #tdf_wholesale, table.csapps-table, .tdf_wholesale_level'));
            });
          });

          if (hasAiodMutation) {
            scheduleTierSync();
          }
        }).observe(tierObserverScope, { childList: true, subtree: true });
      }
    }

    updateAll();
    scheduleTierSync();
    storeExtrasSelection();
    resetUpload();
  };

  document.querySelectorAll('.custom-product-options').forEach(initialize);
})();
